export const CREATE_TRACK_ACTIVITY = 'CREATE_TRACK_ACTIVITY';
export const CREATE_TRACK_ACTIVITY_SUCCESS = 'CREATE_TRACK_ACTIVITY_SUCCESS';
export const CREATE_TRACK_ACTIVITY_FAILED  = 'CREATE_TRACK_ACTIVITY_FAILED';
